export default "__VITE_ASSET__DKzPsTWF__"